"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Skeleton = Skeleton;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = _interopRequireDefault(require("react"));
var _SkeletonThemeContext = require("./SkeletonThemeContext");
var _skeleton = require("./skeleton.style");
var _helpers = require("../../utils/helpers");
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties(_ref) {
  let {
    baseColor,
    highlightColor,
    width,
    height,
    borderRadius,
    direction,
    duration = 1500,
    enableAnimation = defaultEnableAnimation
  } = _ref;
  const style = {};
  if (direction === 'rtl') style['--animation-direction'] = 'reverse';
  if (typeof duration === 'number') {
    style['--animation-duration'] = "".concat(duration, "ms");
  }
  if (!enableAnimation) style['--pseudo-element-display'] = 'none';
  if (typeof width === 'string' || typeof width === 'number') {
    style.width = width;
  }
  if (typeof height === 'string' || typeof height === 'number') {
    style.height = height;
  }
  if (typeof borderRadius === 'string' || typeof borderRadius === 'number') {
    style.borderRadius = borderRadius;
  }
  if (typeof baseColor !== 'undefined') {
    const baseValue = (0, _helpers.findStyledColor)(baseColor);
    style['--base-color'] = typeof baseValue !== 'undefined' && typeof baseValue === 'string' ? baseValue : baseColor;
  }
  if (typeof highlightColor !== 'undefined') {
    const highlightValue = (0, _helpers.findStyledColor)(highlightColor);
    style['--highlight-color'] = typeof highlightValue !== 'undefined' && typeof highlightValue === 'string' ? highlightValue : highlightColor;
  }
  return style;
}
function Skeleton(_a) {
  var _b, _c, _d;
  var {
      count = 1,
      className: customClassName,
      containerClassName,
      variant = 'rounded',
      animation = 'waive',
      style: styleProp
    } = _a,
    originalPropsStyleOptions = __rest(_a, ["count", "className", "containerClassName", "variant", "animation", "style"]);
  const contextStyleOptions = _react["default"].useContext(_SkeletonThemeContext.SkeletonThemeContext);
  const propsStyleOptions = (0, _extends2["default"])({}, originalPropsStyleOptions);
  // DO NOT overwrite style options from the context if `propsStyleOptions`
  // has properties explicity set to undefined
  for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
    if (typeof value === 'undefined') {
      delete propsStyleOptions[key];
    }
  }
  // Props take priority over context
  const styleOptions = (0, _extends2["default"])((0, _extends2["default"])({}, contextStyleOptions), propsStyleOptions);
  // `styleProp` has the least priority out of everything
  const style = (0, _extends2["default"])((0, _extends2["default"])({}, styleProp), styleOptionsToCssProperties(styleOptions));
  let className = 'anchor-skelton-loader';
  if (customClassName) className += " ".concat(customClassName);
  const inline = (_b = styleOptions.inline) !== null && _b !== void 0 ? _b : false;
  const elements = [];
  const countCeil = Math.ceil(count);
  for (let i = 0; i < countCeil; i++) {
    let thisStyle = style;
    if (countCeil > count && i === countCeil - 1) {
      // count is not an integer and we've reached the last iteration of
      // the loop, so add a 'fractional' skeleton.
      //
      // For example, if count is 3.5, we've already added 3 full
      // skeletons, so now we add one more skeleton that is 0.5 times the
      // original width.
      const width = (_c = thisStyle.width) !== null && _c !== void 0 ? _c : '100%'; // 100% is the default since that's what's in the CSS
      const fractionalPart = count % 1;
      const fractionalWidth = typeof width === 'number' ? width * fractionalPart : "calc(".concat(width, " * ").concat(fractionalPart, ")");
      thisStyle = (0, _extends2["default"])((0, _extends2["default"])({}, thisStyle), {
        width: fractionalWidth
      });
    }
    const skeletonSpan = (0, _jsxRuntime.jsx)(_skeleton.SkeletonSpan, (0, _extends2["default"])({
      variant: variant,
      animation: animation,
      className: className,
      style: thisStyle
    }, {
      children: "\u200C"
    }), i);
    if (inline) {
      elements.push(skeletonSpan);
    } else {
      // Without the <br />, the skeleton lines will all run together if
      // `width` is specified
      elements.push((0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
        children: [skeletonSpan, (0, _jsxRuntime.jsx)("br", {})]
      }, i));
    }
  }
  return (0, _jsxRuntime.jsx)(_skeleton.Container, (0, _extends2["default"])({
    className: containerClassName,
    "aria-live": "polite",
    "aria-busy": (_d = styleOptions.enableAnimation) !== null && _d !== void 0 ? _d : defaultEnableAnimation
  }, {
    children: elements
  }));
}